import {
  createContext,
  type SetStateAction,
  type Dispatch,
  type Context,
} from 'react';

import { COMPONENT_NAME } from '../constants.js';

export type MenuContextProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isDefaultOpen: boolean;
  contentId: string;
  dataDtComponent: string;
};

export const MenuContext: Context<MenuContextProps> =
  createContext<MenuContextProps>({
    isOpen: false,
    isDefaultOpen: false,
    setIsOpen: () => null,
    contentId: '',
    dataDtComponent: COMPONENT_NAME,
  });
